import { env } from 'next-runtime-env';

import type { CFImage, MediaTypes, TMedia } from '~constants/media';

export const buildFullUrl = (src: string): string => {
	const PUBLIC_API = env('NEXT_PUBLIC_PUBLIC_API') ?? '';
	return src.startsWith('/') && !src.startsWith('/img') // static import
		? `${PUBLIC_API}${src}`
		: src;
};

export const isImgType = <T extends MediaTypes>(
	item: TMedia,
	...types: T[]
): item is Extract<TMedia, { type: T }> =>
	types.some((type) => type === item.type);

export function selectBestVariant(
	links: CFImage[],
	width: number | `${number}` | undefined,
	height: number | `${number}` | undefined
) {
	const bestSupportedLink =
		links.find(
			(link) =>
				Number(link.heightMax) > Number(height) &&
				Number(link.widthMax) > Number(width)
		) ?? links[links.length - 1];

	return bestSupportedLink.reference;
}
